import { SETTINGS_MODEL_CLASS_NAME } from 'models/daos/settings/constants'
import getEndpointFromClassNameModelUtil from 'models/utils/get-endpoint-from-class-name'
import { loadLegacyReduxAction } from 'modules/redux/actions/legacy/load'
import { saveLegacyReduxAction } from 'modules/redux/actions/legacy/save'
import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import hasChangedReduxUtil from 'modules/redux/utils/has-changed'
import { SETTINGS_DOMAIN } from 'modules/settings/constants'
import { getCurrentUserSettingsSelector } from 'modules/settings/selectors'

/**
 * Loads the current user's settings.
 * @param  {Object} options
 *         {Object} options[APP_JWT]
 * @returns {Function}
 */
function loadSettingsAction (options) {
  return dispatch => {
    return dispatch(
      loadLegacyReduxAction({
        endpoint: getEndpointFromClassNameModelUtil(SETTINGS_MODEL_CLASS_NAME),
        path: SETTINGS_DOMAIN,
        className: SETTINGS_MODEL_CLASS_NAME,
        options
      })
    )
  }
}

/**
 * Changes a setting's property.
 * @param  {string} key
 * @param  {*} value
 * @param  {Object} [options]
 *         {Object} options[APP_JWT]
 * @returns {Function}
 */
function updateSettingsAction (key, value, options) {
  return (dispatch, getState) => {
    const settings = getCurrentUserSettingsSelector()(getState())
    const path = getPathReduxUtil(settings)
    dispatch(
      updateLegacyReduxAction({
        path,
        key,
        value,
        options
      })
    )
  }
}

/**
 * Saves the current user's settings.
 * @returns {Function}
 */
function saveSettingsAction (additionalData) {
  return (dispatch, getState) => {
    // Get the settings
    const settings = getCurrentUserSettingsSelector()(getState())
    // If the settings haven't changed, noop
    if (!hasChangedReduxUtil(settings)) {
      return
    }
    // Save the settings
    const path = getPathReduxUtil(settings)
    return dispatch(
      saveLegacyReduxAction({
        path,
        additionalData
      })
    )
      .then(() => {
      })
  }
}

export {
  loadSettingsAction,
  updateSettingsAction,
  saveSettingsAction
}
